import { entitiesPath } from "@circle-react/helpers/urlHelpers/entitiesPaths";
import { NodeViewWrapper } from "@tiptap/react";

import { t } from "@/i18n-js/instance";

import { EntityMentionChip } from "../EntityMentionChip";
import type { SgidNodeViewProps } from "../types";
import { useSgidObject } from "../useSgidObject";

interface Entity {
  id?: number;
  name: string;
  section_id?: number;
  slug?: string;
  space_slug?: string;
  type: string;
}

export const CircleAiEntityDisplay = ({ node }: SgidNodeViewProps) => {
  const entity = useSgidObject<Entity>(node.attrs.sgid);

  if (!entity) return null;

  const { type, slug, space_slug, section_id, id } = entity;
  const href = new URL(
    entitiesPath({
      type,
      slug: slug ?? "",
      space_slug: space_slug ?? "",
      section_id,
      lesson_id: id,
    }),
    window.location.origin,
  ).toString();

  return (
    <NodeViewWrapper as="span">
      <EntityMentionChip
        prefix="#"
        label={entity.name || t("tiptap.entity_untitled")}
        href={href}
      />
    </NodeViewWrapper>
  );
};
